import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";
import { getFeaturedTopics } from "@/utils/content";

export default function HomeFeatured() {
  const featured = getFeaturedTopics(4);

  return (
    <section className="w-full bg-background-100/60" aria-labelledby="featured-title">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="热点盘点"
          title="最近吃瓜热点盘点"
          description="把这两天讨论度最高的话题重新梳理一遍：发生了什么、大家在意什么、目前进展到哪一步。"
        />
        <div className="mt-8 flex flex-col gap-4">
          {featured.map((topic) => (
            <TopicCard key={topic.id} topic={topic} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}